import styled from "styled-components";
import { Box, IconButton } from "@material-ui/core";

export const ControlContainer = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 4px 0;
`;

export const ControlButtonsContainer = styled(Box)`
    margin-top: 4px;
    display: flex;
    width: 100%;
`;

export const ControlPlayIconButton = styled(IconButton)`
    padding: 0 4px;
    padding-left: 0;
`;

export const ControlIconButton = styled(IconButton)`
    padding: 0 4px;
`;

export const VideoInputRange = styled.input`
    appearance: none;
    margin: 6px 0;
    background: none;
    flex: 1;
    width: 100%;

    &:focus {
        outline: none;
    }

    &::-webkit-slider-runnable-track {
        width: 100%;
        height: 2px;
        cursor: pointer;
        background: ${({ theme }) => theme.palette.primary.main};
        border-radius: 4px;
    }

    &::-webkit-slider-thumb {
        height: 18px;
        width: 8px;
        border-radius: 4px;
        background: ${({ theme }) => theme.palette.secondary[200]};
        cursor: pointer;
        appearance: none;
        margin-top: -8px;
        border: 1px solid ${({ theme }) => theme.palette.primary.main};
    }

    &::-moz-range-track {
        width: 100%;
        height: 2px;
        cursor: pointer;
        background: ${({ theme }) => theme.palette.primary.main};
        border-radius: 4px;
    }

    &::-moz-range-thumb {
        height: 18px;
        width: 6px;
        border-radius: 4px;
        background: ${({ theme }) => theme.palette.secondary[200]};
        cursor: pointer;
    }

    &::-ms-track {
        width: 100%;
        width: 12px;
        cursor: pointer;
        background: transparent;
        border-color: transparent;
        color: transparent;
    }

    &::-ms-fill-lower {
        background: ${({ theme }) => theme.palette.primary.main};
        border-radius: 4px 0px;
    }

    &::-ms-fill-upper {
        background: ${({ theme }) => theme.palette.primary.main};
        border-radius: 4px;
    }

    &::-ms-thumb {
        height: 18px;
        width: 8px;
        border-radius: 4px;
        background: ${({ theme }) => theme.palette.primary.main};
        cursor: pointer;
        height: 4px;
    }
`;

export const AudioInputRange = styled.input`
    position: absolute;
    top: 105px;
    appearance: none;
    margin: 6px 0;
    background: none;
    flex: 1;
    width: 100%;

    &:focus {
        outline: none;
    }

    &::-webkit-slider-runnable-track {
        width: 100%;
        height: 2px;
        cursor: pointer;
        background: ${({ theme }) => theme.palette.primary.main};
        border-radius: 4px;
    }

    &::-webkit-slider-thumb {
        height: 120px;
        width: 1px;
        background: ${({ theme }) => theme.palette.primary.main};
        cursor: pointer;
        appearance: none;
        margin-top: -110px;
    }

    &::-moz-range-track {
        width: 100%;
        height: 2px;
        cursor: pointer;
        background: ${({ theme }) => theme.palette.primary.main};
        border-radius: 4px;
    }

    &::-moz-range-thumb {
        height: 140px;
        width: 0;
        background: ${({ theme }) => theme.palette.primary.main};
        cursor: pointer;
        appearance: none;
        transform: translateY(-64px);
    }

    &::-ms-track {
        width: 100%;
        width: 12px;
        cursor: pointer;
        background: transparent;
        border-color: transparent;
        color: transparent;
    }

    &::-ms-fill-lower {
        background: ${({ theme }) => theme.palette.primary.main};
        border-radius: 4px 0px;
    }

    &::-ms-fill-upper {
        background: ${({ theme }) => theme.palette.primary.main};
        border-radius: 4px;
    }

    &::-ms-thumb {
        height: 120px;
        width: 1px;
        background: ${({ theme }) => theme.palette.primary.main};
        cursor: pointer;
        appearance: none;
        margin-top: -110px;
    }
`;
